// 3_pages/product_product_top.js
// Product detail top: restructures the product header (reviews, code, parameters,
// availability/delivery, price+button) responsively, builds the image carousel from
// thumbnails, moves flags, and adds the charity-support element.

import {
	bindDeliveryTooltipInteractions,
	enhanceDeliveryTooltips,
} from "../2_components/delivery_tooltip.js";
import { applyGlossary } from "../2_components/slovnik_pojmu.js";

export function init() {
	if (!document.body.classList.contains("type-product")) return;

	moveElementProductTop();
	applyGlossary("#description");
	fillCouponAndLoyaltyNotices();

	document.addEventListener("DOMContentLoaded", function () {
		const thumbnailsWrapper = document.querySelector(".p-thumbnails-inner");
		const thumbnailsParent = document.querySelector(".p-thumbnails-inner > div");
		const thumbnails = document.querySelectorAll(".p-thumbnail");
		if (thumbnails && thumbnailsParent && thumbnailsWrapper) {
			window.NAT.utils.initializeSliderElement(
				thumbnailsWrapper,
				thumbnailsParent,
				thumbnails,
				"thumbnails-slider",
				null,
			);
			makeCarouselFromImages();
		}
	});

	/*Možnosti doručení popup*/
	/* editDeliveryPricesPopup(); */
}

function fillCouponAndLoyaltyNotices() {
	document.querySelectorAll(".nelze-uplatnit-slevovy-kod, .nelze-uplatnit-slevovy-kupon").forEach((el) => {
		el.innerHTML = "<p>" + window.NAT.translations("noSaleCoupon") + "</p>";
	});
	document.querySelectorAll(".nelze-uplatnit-vernostni-slevu").forEach((el) => {
		el.innerHTML = "<p>" + window.NAT.translations("noLoyaltySale") + "</p>";
	});
}

function moveElementProductTop() {
	const productTop = document.querySelector(".product-top");
	const pImageWrapper = document.querySelector(".p-image-wrapper");
	const pInfoWrapper = document.querySelector(".p-info-wrapper");

	if (!productTop || !pImageWrapper || !pInfoWrapper) {
		console.warn("Required elements for moving product top are missing.");
		return;
	}

	const reviewAndCodeWrapper = document.createElement("div");
	reviewAndCodeWrapper.classList.add("review-and-code-wrapper");
	const starsWrapperTop = document.querySelector(".stars-wrapper");
	if (starsWrapperTop) {
		addNumberOfReviewsToProductTop(starsWrapperTop);
		reviewAndCodeWrapper.appendChild(starsWrapperTop);
	}
	const productCode = document.querySelector(".p-detail-inner .p-code");
	if (productCode) {
		reviewAndCodeWrapper.appendChild(productCode);
	}

	const pDetailInnerHeader = document.querySelector(".p-detail-inner-header");
	if (pDetailInnerHeader) {
		pDetailInnerHeader.append(reviewAndCodeWrapper);
	}

	addSupportToImageWrapper(pImageWrapper);

	productTopDependingOnDevice(productTop, pImageWrapper, pInfoWrapper);
	document.addEventListener("debouncedResize", function () {
		productTopDependingOnDevice(productTop, pImageWrapper, pInfoWrapper);
	});

	addParametersToProductTop(pInfoWrapper);
	availabilityAndDeliveryWrapper(productTop, pInfoWrapper);
	priceAndButtonWrapper(productTop, pInfoWrapper);
	readMoreDescription(productTop, pInfoWrapper);
	moveFlagsToImageWrapper(productTop, pImageWrapper);
	addListenerToThumbnails(pImageWrapper);
}

function productTopDependingOnDevice(productTop, pImageWrapper, pInfoWrapper) {
	if (window.NAT.media.isSmallTablet) {
		const breadCrumbsWrapper = document.querySelector(".breadcrumbs-wrapper");
		if (breadCrumbsWrapper) {
			const header = document.querySelector("#header");
			if (header) {
				//insert breadcrumbs after header
				header.after(breadCrumbsWrapper);
			}
		}
		const productH1 = document.querySelector(".p-info-wrapper h1");
		if (productH1) {
			const pDetailInnerHeader = document.querySelector(".p-detail-inner-header");
			if (pDetailInnerHeader) {
				pDetailInnerHeader.prepend(productH1);
			}
		}

		const reviewAndCodeWrapper = document.querySelector(".p-info-wrapper .review-and-code-wrapper");
		if (reviewAndCodeWrapper) {
			const pDetailInnerHeader = document.querySelector(".p-detail-inner-header");
			if (pDetailInnerHeader) {
				pDetailInnerHeader.appendChild(reviewAndCodeWrapper);
			}
		}
		const pCode = document.querySelector(".review-and-code-wrapper .p-code");
		if (pCode) {
			pInfoWrapper.appendChild(pCode);
		}

		const productImageSupportElement = pImageWrapper.querySelector(".product-image-support-element");
		if (productImageSupportElement) {
			pInfoWrapper.appendChild(productImageSupportElement);
		}
	}

	if (!window.NAT.media.isSmallTablet) {
		const breadCrumbsWrapper = document.querySelector(".overall-wrapper > .breadcrumbs-wrapper");
		if (breadCrumbsWrapper) {
			pInfoWrapper.prepend(breadCrumbsWrapper);
		}
		const productH1 = document.querySelector(".p-detail-inner h1");
		if (productH1) {
			pInfoWrapper.prepend(productH1);
		}

		const reviewAndCodeWrapper = document.querySelector(".review-and-code-wrapper");
		if (reviewAndCodeWrapper) {
			pInfoWrapper.appendChild(reviewAndCodeWrapper);
			const pCode = pInfoWrapper.querySelector(".p-code");
			if (pCode) {
				reviewAndCodeWrapper.appendChild(pCode);
			}
		}

		const productImageSupportElement = pInfoWrapper.querySelector(".product-image-support-element");
		if (productImageSupportElement) {
			pImageWrapper.appendChild(productImageSupportElement);
		}
	}
}

function addNumberOfReviewsToProductTop(starsWrapperTop) {
	const starElement = starsWrapperTop.querySelector(".star");
	if (!starElement) {
		return;
	}
	let starsScore = starElement.getAttribute("title") || starElement.getAttribute("data-original-title");

	if (starsScore) {
		starsScore = starsScore.split(":")[1].split("/")[0].trim();
		starsScore = parseFloat(starsScore).toFixed(2).replace(".", ",");
		if (starsScore != null && starsScore != "NaN") {
			const starsScoreElement = document.createElement("div");
			starsScoreElement.className = "stars-score";
			starsScoreElement.innerHTML = `<span class="stars-score-text">${starsScore}</span> / 5`;
			starsWrapperTop.appendChild(starsScoreElement);
		} else {
			starsWrapperTop.classList.add("no-score");
			const ratingTab = document.querySelector("#ratingTab");
			if (ratingTab) {
				ratingTab.classList.add("no-score");
			}
			const starsLabel = starsWrapperTop.querySelector(".stars-label");
			if (starsLabel) {
				starsLabel.textContent = window.NAT.translations("insertFirstReview");
			}
		}
	}
}

function addParametersToProductTop(pInfoWrapper) {
	const detailParameters = document.querySelector(".extended-description .detail-parameters");
	if (!detailParameters) {
		return;
	}
	const ratingTab = document.querySelector("#ratingTab");
	if (ratingTab) {
		//insert detail parameters after rating tab
		ratingTab.after(document.querySelector(".extended-description"));
	}

	const trSoldOut = detailParameters.querySelector("tr.sold-out");
	if (trSoldOut) {
		trSoldOut.remove();
	}

	const parametersToMove = detailParameters.querySelectorAll("tr");
	if (!parametersToMove || parametersToMove.length === 0) {
		return;
	}

	const detailParametersTop = document.createElement("div");
	detailParametersTop.classList.add("detail-parameters-top");

	parametersToMove.forEach((parameter, index) => {
		if (index <= 3) {
			const parameterValue = parameter.querySelector("td").textContent;

			if (parameterValue.toLowerCase().includes("doplněk")) {
				const productName = document.querySelector("h1");

				if (productName) {
					const productNameAddition = document.createElement("span");
					productNameAddition.classList.add("product-name-addition");
					productNameAddition.innerHTML = "–&nbsp;" + parameterValue.trim();
					productName.appendChild(productNameAddition);
					return;
				}
			}
		}
		if (index > 3) {
			const parameterWrapper = document.createElement("div");
			parameterWrapper.classList.add("parameter-wrapper");

			const parameterName = document.createElement("div");
			parameterName.classList.add("parameter-name");
			parameterName.textContent = parameter.querySelector("th").textContent.replace(":", "");

			const parameterValue = document.createElement("div");
			parameterValue.classList.add("parameter-value");
			parameterValue.textContent = parameter.querySelector("td").textContent;

			//vhodné pro
			if (parameterName.textContent.toLowerCase().includes("vhodné")) {
				const productUl = document.querySelector(".product-top .p-short-description ul");
				if (productUl) {
					const vhodneProElement = document.createElement("li");
					vhodneProElement.innerHTML = parameterName.textContent.trim() + ":" + parameter.querySelector("td").innerHTML;
					productUl.appendChild(vhodneProElement);

					//end this cycle of loop and move on to next parameter
					return;
				}
			}

			parameterWrapper.appendChild(parameterName);
			parameterWrapper.appendChild(parameterValue);
			detailParametersTop.appendChild(parameterWrapper);
		}
	});

	const shortDescription = pInfoWrapper.querySelector(".p-short-description");
	if (shortDescription) {
		shortDescription.insertBefore(detailParametersTop, shortDescription.querySelector(":scope > .pv-variants"));
	} else {
		pInfoWrapper.appendChild(detailParametersTop);
	}
}

function availabilityAndDeliveryWrapper(productTop, pInfoWrapper) {
	let wrapper = productTop.querySelector(".availability-and-delivery-wrapper");
	if (!wrapper) {
		wrapper = document.createElement("div");
		wrapper.classList.add("availability-and-delivery-wrapper");
	}

	const availabilityValue = wrapper.querySelector(".availability-value") || document.querySelector(".availability-value");
	if (availabilityValue) {
		editAvailabilityText(availabilityValue);
		if (availabilityValue.parentElement !== wrapper) {
			wrapper.appendChild(availabilityValue);
		}
	}

	const deliveryTime = wrapper.querySelector(".delivery-time") || productTop.querySelector(".delivery-time");
	if (deliveryTime) {
		editDeliveryDateText(deliveryTime);
		if (deliveryTime.parentElement !== wrapper) {
			wrapper.appendChild(deliveryTime);
		}
	}

	const shippingOptions =
		wrapper.querySelector("a.shipping-options") || productTop.querySelector("a.shipping-options");
	if (shippingOptions && shippingOptions.parentElement !== wrapper) {
		wrapper.appendChild(shippingOptions);
	}

	if (wrapper.parentElement !== pInfoWrapper) {
		pInfoWrapper.appendChild(wrapper);
	}
	enhanceDeliveryTooltips(wrapper);
	bindDeliveryTooltipInteractions();
}

function editAvailabilityText(availabilityValue) {
	const availabilityAmount = availabilityValue.querySelector(".availability-amount");
	if (!availabilityAmount) {
		return;
	}
	availabilityAmount.textContent = availabilityAmount.textContent.replace("(", "").replace(")", "").trim();
	availabilityAmount.textContent = availabilityAmount.textContent
		.replace(">", window.NAT.translations("moreThan"))
		.trim();
}

function editDeliveryDateText(deliveryTime) {
	if (deliveryTime.querySelector(".delivery-text-1")) {
		return;
	}
	const deliveryText1 = document.createElement("span");
	deliveryText1.classList.add("delivery-text-1");
	deliveryText1.textContent = window.NAT.translations("deliveryTime_1") + " ";

	const deliveryText2 = document.createElement("span");
	deliveryText2.classList.add("delivery-text-2");
	deliveryText2.textContent = " " + window.NAT.translations("deliveryTime_2");

	deliveryTime.prepend(deliveryText1);
	deliveryTime.appendChild(deliveryText2);
}

function priceAndButtonWrapper(productTop, pInfoWrapper) {
	const priceAndButtonWrapperWrapper = document.createElement("div");
	priceAndButtonWrapperWrapper.classList.add("price-and-button-wrapper-wrapper");

	const priceAndButtonWrapper = document.createElement("div");
	priceAndButtonWrapper.classList.add("price-and-button-wrapper");

	priceAndButtonWrapperWrapper.appendChild(priceAndButtonWrapper);
	pInfoWrapper.appendChild(priceAndButtonWrapperWrapper);

	const priceStandard = pInfoWrapper.querySelector(".price-standard");
	if (priceStandard) {
		priceAndButtonWrapper.appendChild(priceStandard);
	} else {
		priceAndButtonWrapper.classList.add("no-standard-price");
	}

	const priceFinal = pInfoWrapper.querySelector(".price-final");
	if (priceFinal) {
		const withVatInfo = document.createElement("span");
		withVatInfo.classList.add("with-vat-info");
		withVatInfo.textContent = window.NAT.translations("withVAT");
		priceFinal.appendChild(withVatInfo);
		priceAndButtonWrapper.appendChild(priceFinal);
	}

	const quantity = pInfoWrapper.querySelector(".quantity");
	if (quantity) {
		priceAndButtonWrapper.appendChild(quantity);
	}

	const addToCartButton = pInfoWrapper.querySelector(".add-to-cart-button");
	if (addToCartButton) {
		priceAndButtonWrapper.appendChild(addToCartButton);
	} else {
		//tady bude co se stane když není k prodeji
		const watchdog = document.querySelector(".product-top .watchdog");
		if (watchdog) {
			const notifyMeButton = document.createElement("div");
			notifyMeButton.classList.add("notify-me-button");
			notifyMeButton.classList.add("custom-add-to-cart-button");

			notifyMeButton.textContent = window.NAT.translations("watchDog");

			priceAndButtonWrapper.appendChild(notifyMeButton);
			notifyMeButton.addEventListener("click", function () {
				watchdog.click();
			});
		}

		const souvisejiciProdukty = document.querySelector(".products-related");
		if (souvisejiciProdukty) {
			const showSimiliarProductsButton = document.createElement("div");
			showSimiliarProductsButton.className = "show-similiar-products-button";

			showSimiliarProductsButton.textContent = window.NAT.translations("showRelatedProducts");

			priceAndButtonWrapper.appendChild(showSimiliarProductsButton);
			showSimiliarProductsButton.addEventListener("click", function () {
				window.NAT.utils.scrollToElement(souvisejiciProdukty);
			});
		}
	}

	//dispatch event after moving price and button
	const event = new Event("priceAndButtonMoved");
	document.dispatchEvent(event);
	console.log(
		"%c priceAndButtonMoved event dispatched ",
		"background: lime; color: black; padding: 5px 10px; font-weight: bold;",
	);
}

function readMoreDescription(productTop, pInfoWrapper) {
	const readMoreDescriptionBtn = productTop.querySelector("p[data-testid='productCardDescr']");
	const socialButtonsWrapper = productTop.querySelector(".social-buttons-wrapper");

	if (readMoreDescriptionBtn && socialButtonsWrapper) {
		const readMoreDescriptionBtnA = readMoreDescriptionBtn.querySelector("a");
		if (readMoreDescriptionBtnA) {
			readMoreDescriptionBtnA.textContent = window.NAT.translations("readMore");
		}
		socialButtonsWrapper.appendChild(readMoreDescriptionBtn);
	}
}

function moveFlagsToImageWrapper(productTop, pImageWrapper) {
	const flagsDefault = productTop.querySelector(".flags-default");
	const pImage = pImageWrapper.querySelector(".p-image");
	if (flagsDefault && pImage) {
		pImage.appendChild(flagsDefault);
	}
}

function addListenerToThumbnails(pImageWrapper) {
	const thumbnails = pImageWrapper.querySelectorAll(".p-thumbnail");
	if (!thumbnails || thumbnails.length === 0) {
		return;
	}
	const pMainImage = pImageWrapper.querySelector(".p-main-image");
	if (!pMainImage) {
		return;
	}
	pMainImage.classList.add("first-image");
	/* thumbnails.forEach((thumbnail, index) => {
		thumbnail.addEventListener("click", function (event) {
			if (index !== 0) {
				pMainImage.classList.add("no-first-image");
			} else {
				pMainImage.classList.remove("no-first-image");
			}
		});
	}); */
}

function addSupportToImageWrapper(pImageWrapper) {
	const supportElement = document.createElement("div");
	supportElement.classList.add("product-image-support-element");

	const supportText = document.createElement("span");
	supportText.classList.add("support-text");
	supportText.innerHTML = window.NAT.translations("natiosSupportTextTop");

	const supportLink = document.createElement("a");
	supportLink.classList.add("support-link");
	supportLink.href = window.NAT.translations("natiosSupportPageUrl");
	supportLink.textContent = window.NAT.translations("more");

	supportElement.appendChild(supportText);
	supportElement.appendChild(supportLink);

	pImageWrapper.appendChild(supportElement);
}

function makeCarouselFromImages() {
	const productTopImage = document.querySelector(".product-top .p-image-wrapper .p-main-image");
	if (!productTopImage) {
		return;
	}

	//wrap productTopImage in image-carousel-wrapper
	const imageCarouselWrapper = document.createElement("div");
	imageCarouselWrapper.classList.add("image-carousel-wrapper");
	productTopImage.parentNode.insertBefore(imageCarouselWrapper, productTopImage);
	imageCarouselWrapper.appendChild(productTopImage);

	const allImagesInThumbnails = document.querySelectorAll(".p-thumbnails-inner .p-thumbnail");
	if (!allImagesInThumbnails || allImagesInThumbnails.length === 0 || allImagesInThumbnails.length === 1) {
		return;
	}
	let imageIndex = 0;
	allImagesInThumbnails.forEach((thumbnail, index) => {
		if (index !== 0) {
			const thumbnailClone = thumbnail.cloneNode(true);
			const thumbnailHref = thumbnailClone.getAttribute("href");
			const thumbnailImage = thumbnailClone.querySelector("img");

			if (thumbnailImage) {
				thumbnailImage.setAttribute("src", thumbnailHref);
				thumbnailImage.setAttribute("data-src", thumbnailHref);
			}
			thumbnailClone.classList.add("p-main-image");
			thumbnailClone.classList.add("no-first-image");

			thumbnailClone.classList.remove("p-thumbnail");
			imageCarouselWrapper.appendChild(thumbnailClone);
		}
		thumbnail.removeAttribute("href");

		thumbnail.addEventListener("click", function (event) {
			event.preventDefault();
			imageIndex = index;
			transformTopImage();
			const activeThumbnail = document.querySelector(".p-thumbnails-inner .p-thumbnail.active");
			if (activeThumbnail) {
				activeThumbnail.classList.remove("active");
			}
			thumbnail.classList.add("active");
		});
	});

	const imagesWrapper = document.querySelector(".p-image-wrapper .p-image");
	const allImagesInCarousel = imageCarouselWrapper.querySelectorAll(".p-main-image");

	window.NAT.utils.initializeSliderElementSnap(
		imagesWrapper,
		imageCarouselWrapper,
		allImagesInCarousel,
		"main-images-slider",
		"img",
		true,
	);

	changeActiveThumbnail();

	let thumbnailDebounce;
	imageCarouselWrapper.addEventListener("scroll", function () {
		const imageWidth = allImagesInCarousel[0].clientWidth;
		imageIndex = Math.round(imageCarouselWrapper.scrollLeft / imageWidth);
		clearTimeout(thumbnailDebounce);
		thumbnailDebounce = setTimeout(changeActiveThumbnail, 80);
	});

	function transformTopImage() {
		if (!allImagesInCarousel) return;

		const imageWidth = allImagesInCarousel[0].clientWidth;
		imageCarouselWrapper.scrollTo({
			left: imageIndex * imageWidth,
			behavior: "smooth",
		});
	}
	function changeActiveThumbnail() {
		allImagesInThumbnails.forEach((thumbnail, thumbnailIndex) => {
			if (thumbnailIndex === imageIndex) {
				thumbnail.classList.add("active");
			} else {
				thumbnail.classList.remove("active");
			}
		});
	}
	moveFavouritesDivToSlider();
	function moveFavouritesDivToSlider() {
		const favoritesInInfoWrapper = document.querySelector(".p-image-wrapper > .dkLabFavouriteDiv");
		if (favoritesInInfoWrapper) {
			const appendFavouritesToThis = document.querySelector(".p-image-wrapper .image-carousel-wrapper");
			if (appendFavouritesToThis) {
				appendFavouritesToThis.appendChild(favoritesInInfoWrapper);
			}
		}
	}
}

/*Možnosti doručení popup*/
/* 	function editDeliveryPricesPopup() {
		let lastShippingCheck = Date.now();
		const observerShippingOptions = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (mutation.type === "childList") {
					const shippingOptionsPopup = document.querySelector(".shipping-options-popup");
					const now = Date.now();

					if (shippingOptionsPopup) {
						if (now - lastShippingCheck < 1000) {
							return; // Skip if the last check was less than 1 second ago
						}
						lastShippingCheck = now;


						changePricesInShippingTooltip();
					}
				}
			}
		});

		observerShippingOptions.observe(document.body, { childList: true, subtree: true });

		function changePricesInShippingTooltip() {
			let shippingOptionsPopup = document.querySelector(".shipping-options-popup");
			if (!shippingOptionsPopup) return;
			let priceRange = shippingOptionsPopup.querySelector(".price-range");
			if (!priceRange) return;

			let shippingPrices = {};

				shippingPrices = {
					"Zásilkovna (Odběrné místo)": "49 Kč",
					"Balíkovna - ČP (Výdejní místa)": "49 Kč",
					"DPD (Pick Up) - Výdejní místa": "49 Kč",
					"DPD (Doručení na adresu)": "79 Kč",
					"Balíkovna na adresu - ČP": "85 Kč",
					"Zásilkovna (Doručení na adresu)": "89 Kč",
				};



			document.querySelectorAll(".shipping-billing-name").forEach((nameEl) => {
				const name = nameEl.textContent.trim().replace(/\s+/g, " ");
				const price = shippingPrices[name];
				if (price) {
					const priceEl = nameEl.closest(".shipping-row")?.querySelector(".payment-shipping-price");
					if (priceEl) {
						priceEl.textContent = price;
						priceEl.classList.remove("for-free");
					}
				}
			});
		}
	} */
